import type { ReactNode } from "react";
import { Tabs } from "antd";
import styles from "./Tabs.module.scss";

export function PageTabs<K extends string>({
  activeKey,
  onChange,
  items,
}: {
  activeKey: K;
  onChange: (key: K) => void;
  items: { key: K; label: ReactNode }[];
}) {
  return (
    <Tabs
      activeKey={activeKey}
      onChange={(key) => onChange(key as K)}
      items={items.map((item) => ({
        key: item.key,
        label: item.label,
      }))}
      className={styles.pillTabs}
    />
  );
}
